import React from 'react';
import '../styles/Signup.css';

function Signup() {
  return (
    <section className="signup">
      <div className="signup-content">
        <h2>Join Our Mailing List</h2>
        <form className="signup-form">
          <input
            type="email"
            className="email-input"
            placeholder="Your email address"
            required
          />
          <button type="submit" className="signup-btn">
            Sign me up
          </button>
        </form>
      </div>
    </section>
  );
}

export default Signup;
